import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { AuthTypeComponent } from '../auth-type.shared.component';

@Component({
    selector: 'shared-auth-for-cell-sign-in',
    templateUrl: './auth-for-cell-sign-in.shared.component.html',
    styleUrls: ['./auth-for-cell-sign-in.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthForCellSignInComponent extends AuthTypeComponent implements OnInit {
    public phoneNo$: Observable<string>;

    constructor(
        public controllers: Controllers,
    ) {
        super(controllers);
    }

    ngOnInit(): void {
        this.phoneNo$ = this.controllers.members.getObfuscatedMemberPhoneNo$();
    }
}
